import { render, staticRenderFns } from "./SelectorPopup.vue?vue&type=template&id=f3a23bf6&scoped=true"
import script from "./SelectorPopup.vue?vue&type=script&lang=ts"
export * from "./SelectorPopup.vue?vue&type=script&lang=ts"
import style0 from "./SelectorPopup.vue?vue&type=style&index=0&id=f3a23bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a23bf6",
  null
  
)

export default component.exports